common.View.create('canvas.blocks.custom.video.Block', {
    onDOMLoad() {
        this.initPlayButton();
    },

    initPlayButton() {
        let video = this.element.find('video');
        let videoEl = video[0];
        let playButton = this.element.find('#playButton');

        if (!video || !videoEl) {
            return;
        }

        // Play button click handler
        playButton.on('click', () => {
            this.toggleVideo(videoEl);
        });

        // Video click handler for play/pause
        video.on('click', () => {
            this.toggleVideo(videoEl);
        });

        setInterval(() => {
            videoEl.paused === true ? this.showPlayButton() : this.hidePlayButton();
        }, 100);
    },

    toggleVideo(videoEl) {
        if (videoEl.paused) {
            videoEl.play();
            this.hidePlayButton();
        } else {
            videoEl.pause();
            this.showPlayButton();
        }
    },

    showPlayButton() {
        let playButton = this.element.find('#playButton');
        let overlay = this.element.find('.overlay');
        playButton.addClass('pointer-events-auto');
        playButton.removeClass('opacity-0 pointer-events-none');
        overlay.removeClass('opacity-0');
    },

    hidePlayButton() {
        let playButton = this.element.find('#playButton');
        let overlay = this.element.find('.overlay');
        playButton.removeClass('pointer-events-auto');
        playButton.addClass('opacity-0 pointer-events-none');
        overlay.addClass('opacity-0');
    },
});
